exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".raroc-header-container {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.raroc-header-container .raroc-header-title {\n  color: #c50f2f;\n  border-left: 6px #c50f2f solid;\n  flex: 1;\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 36px;\n  text-align: left;\n  padding-left: 4px;\n  margin: 0;\n  margin-bottom: 24px;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/resolve-url-loader!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/pages/Raroc/Dashboard/Header/header.style.scss
// module id = ./node_modules/css-loader/index.js!./node_modules/resolve-url-loader/index.js!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/pages/Raroc/Dashboard/Header/header.style.scss
// module chunks = 0